import React, { useMemo } from "react";
import { array, bool, func, string } from "prop-types";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

function SearchableCountrySelect({
  countries,
  value,
  onChange,
  label,
  name,
  required,
  placeholder,
  className,
}) {
  const options = useMemo(
    () => (Array.isArray(countries) ? countries : []),
    [countries],
  );

  const selectedCountry = useMemo(
    () =>
      options.find((country) => String(country.id) === String(value ?? "")) ||
      null,
    [options, value],
  );

  const handleChange = (_event, country) => {
    if (!onChange) return;
    onChange({
      target: {
        name: name || "country",
        value: country ? country.id : "",
      },
    });
  };

  return (
    <div className={`custom-input w-100 mt-3 ${className || ""}`}>
      <label className="d-block mb-0" htmlFor={name || "country"}>
        {label}
        {required && <span className="co-lightred"> *</span>}
      </label>
      <Autocomplete
        id={name || "country"}
        options={options}
        value={selectedCountry}
        onChange={handleChange}
        getOptionLabel={(option) => option?.name || ""}
        getOptionSelected={(option, selected) =>
          String(option.id) === String(selected.id)
        }
        PopperProps={{
          placement: "bottom-start",
          modifiers: {
            flip: { enabled: false },
            preventOverflow: {
              enabled: true,
              boundariesElement: "viewport",
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            variant="outlined"
            placeholder={placeholder}
            required={required}
          />
        )}
        noOptionsText="No country found"
      />
    </div>
  );
}

SearchableCountrySelect.propTypes = {
  countries: array,
  value: string,
  onChange: func.isRequired,
  label: string,
  name: string,
  required: bool,
  placeholder: string,
  className: string,
};

SearchableCountrySelect.defaultProps = {
  countries: [],
  value: "",
  label: "Primary Country (Host Location)",
  name: "country",
  required: false,
  placeholder: "Search countries...",
  className: "",
};

export default SearchableCountrySelect;
